var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeniedMfa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6B696A",
    d: "M4.703 9.406C2.11 9.406 0 7.297 0 4.703 0 2.11 2.11 0 4.703 0c2.593 0 4.703 2.11 4.703 4.703 0 2.594-2.11 4.703-4.703 4.703m0-8.304c-1.985 0-3.601 1.616-3.601 3.601 0 1.986 1.616 3.6 3.601 3.6 1.985 0 3.601-1.614 3.601-3.6 0-1.985-1.616-3.601-3.601-3.601",
    transform: "translate(-67 -112) translate(67.9 113.738) translate(4.302 8.148)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6B696A",
    strokeWidth: 0.5,
    d: "M4.703 9.406C2.11 9.406 0 7.297 0 4.703 0 2.11 2.11 0 4.703 0c2.593 0 4.703 2.11 4.703 4.703 0 2.594-2.11 4.703-4.703 4.703m0-8.304c-1.985 0-3.601 1.616-3.601 3.601 0 1.986 1.616 3.6 3.601 3.6 1.985 0 3.601-1.614 3.601-3.6 0-1.985-1.616-3.601-3.601-3.601",
    transform: "translate(-67 -112) translate(67.9 113.738) translate(4.302 8.148)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6B696A",
    d: "M18.007 25.561c-.041-3.637-2.25-6.762-5.393-8.143-.351.29-.737.538-1.152.738 3.127 1.026 5.399 3.95 5.442 7.405H1.105c.044-3.454 2.316-6.38 5.442-7.405-.414-.2-.801-.448-1.152-.738C2.252 18.797.043 21.924.002 25.56H0v1.1h18.009v-1.1h-.002z",
    transform: "translate(-67 -112) translate(67.9 113.738)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6B696A",
    strokeWidth: 0.5,
    d: "M18.007 25.561c-.041-3.637-2.25-6.762-5.393-8.143-.351.29-.737.538-1.152.738 3.127 1.026 5.399 3.95 5.442 7.405H1.105c.044-3.454 2.316-6.38 5.442-7.405-.414-.2-.801-.448-1.152-.738C2.252 18.797.043 21.924.002 25.56H0v1.1h18.009v-1.1h-.002z",
    transform: "translate(-67 -112) translate(67.9 113.738)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M26.811 21.02H13.19c-.657 0-1.189-.532-1.189-1.189V1.189C12 .532 12.532 0 13.19 0H26.81c.657 0 1.19.532 1.19 1.189v18.642c0 .657-.533 1.189-1.19 1.189",
    transform: "translate(-67 -112) translate(67.9 113.738)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M26.811 21.02H13.19c-.657 0-1.189-.532-1.189-1.189V1.189C12 .532 12.532 0 13.19 0H26.81c.657 0 1.19.532 1.19 1.189v18.642c0 .657-.533 1.189-1.19 1.189z",
    transform: "translate(-67 -112) translate(67.9 113.738)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#368FEF",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 12,
    fontWeight: "bold",
    transform: "translate(-67 -112) translate(67.9 113.738)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16.35,
    y: 11.829
  }, "X")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeniedMfa);
export default __webpack_public_path__ + "static/media/denied_mfa.d19dfb0664a2ed45ace46f5e64bf7715.svg";
export { ForwardRef as ReactComponent };